module.exports = __webpack_public_path__ + "media/images/submit-btn-6ba51389ea59764540a6a6a022e94212.png";